<template>
  <div class="page-content">
    <div class="card">
      <h3>There was an error with your payment</h3>
      <SnackbarPrompt icon="warning" variation="warning">{{
        errorMessage
      }}</SnackbarPrompt>
      <CustomButton variation="primary" :onClick="goBack">Back</CustomButton>
    </div>
  </div>
</template>
<script>
import SnackbarPrompt from "@/components/SnackbarPrompt.vue";
import CustomButton from "@/components/CustomButton.vue";
export default {
  props: {
    errorMessage: String,
    goBack: Function,
  },
  components: {
    SnackbarPrompt,
    CustomButton,
  },
};
</script>
